import ThreeColumns from "./ThreeColumns";

export default ThreeColumns;
